module.exports = __webpack_public_path__ + "static/media/Erin Freeburger.408c4caa.png";